import React from 'react';
import { View } from 'react-native';

export default ({ children, style }) => <View style={style}>{children}</View>;


// WEBPACK FOOTER //
// ./src/components/third-party/react-native-safe-area-view/index.web.js